import { CREATEJS_UTILITIES_LOGGER } from "../../../../../index";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER);

export class TextSnapshot {
    public readonly charCount: number = 0;

    public findText(beginIndex: number, textToFind: string, caseSensitive: boolean): number {
        logger.warn("TextSnapshot.findText is not implemented");
        return 0;
    }

    public getSelected(beginIndex: number, endIndex: number): boolean {
        logger.warn("TextSnapshot.getSelected is not implemented");
        return false;
    }

    public getSelectedText(includeLineEndings: boolean = false): string {
        logger.warn("TextSnapshot.getSelectedTExt is not implemented");
        return "";
    }

    public getText(beginIndex: number, endIndex: number, includeLineEndings: boolean = false): string {
        logger.warn("TextSnapshot.getText is not implemented");
        return "";
    }

    public getTextRunInfo(beginIndex: number, endIndex: number): Array<any> {
        logger.warn("TextSnapshot.getTextRunInfo is not implemented");
        return [];
    }

    public hitTestTextNearPos(x: number, y: number, maxDistance: number = 0): number {
        logger.warn("TextSnapshot.hitTestTextNearPos is not implemented");
        return 0;
    }

    public setSelectColor(hexColor: number = 1): void {
        logger.warn("TextSnapshot.setSelectColor is not implemented");
    }

    public setSelected(beginIndex: number, endIndex: number, select: boolean): void {
        logger.warn("TextSnapshot.setSelected is not implemented");
    }
}
